import {commaSeparate, areObjectArraysEmpty, getMonthsWord} from "../modules/helpers.js";
import {getDashboardData} from "../modules/dashboard.js"
import {hideContent, parseObjectiveName} from "./ui-helpers.js"
import {globals, globalUser} from "../modules/globals.js";
import {loadAvailableCallupsPage} from "./home-page.js";
import {playSoundEffect} from "./sounds.js"

async function dashboardHandler() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Unselect menus
    $('.main-menu-container').find('li').removeClass('selected');
    $("#main-menu-right").html('');
    $(this).addClass('selected');

    // Hide event effects
    $('.event-prestige-effects-container').hide();
    $('.event-prestige-effects-more i').addClass('fa-angle-down').removeClass('fa-angle-up');
    $('#matches .event-card-match-edit-menu').find('.selected').removeClass('selected');

    // Load dashboard
    await loadDashboard();
}

async function loadDashboard() {  // Previously getDashboardData
    // Get dashboard data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let dashboardData = await getDashboardData();

    // Show dashboard data
    hideContent($());
    globals.requestRunning = false;
    notie.hideAlerts();
    showDashboardData(dashboardData);
}

function showDashboardData(data) {
    const $dashboardBox = $('#dashboard-box');
    const $dashboardContainer = $('#dashboard-container');
    $dashboardBox.html('');
    $dashboardContainer.show();
    $dashboardBox.scrollTop(0);

    let div = '';

    // Alerts
    if (data['alerts']) {
        div += '<span class="display-block blue">Alerts</span>';

        if (data['alerts']['buyoutAvailable'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['buyoutAvailable'][0] + ' is available for a buyout</span>';
        } else if (data['alerts']['buyoutAvailable'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['buyoutAvailable']) + ' are available for a buyout</span>';
        }

        if (data['alerts']['companyFormed'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['companyFormed'][0] + ' formed</span>';
        } else if (data['alerts']['companyFormed'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['companyFormed']) + ' formed</span>';
        }

        if (data['alerts']['companyFolded'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['companyFolded'][0] + ' folded</span>';
        } else if (data['alerts']['companyFolded'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['companyFolded']) + ' folded</span>';
        }

        if (data['alerts']['leftCompany'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['leftCompany'][0] + ' left the company</span>';
        } else if (data['alerts']['leftCompany'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['leftCompany']) + ' left the company</span>';
        }

        if (data['alerts']['superstarRetired'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['superstarRetired'][0] + ' retired from wrestling</span>';
        } else if (data['alerts']['superstarRetired'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['superstarRetired']) + ' retired from wrestling</span>';
        }

        if (data['alerts']['staffMemberRetired'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['staffMemberRetired'][0] + ' retired from their job</span>';
        } else if (data['alerts']['staffMemberRetired'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['staffMemberRetired']) + ' retired from their jobs</span>';
        }

        if (data['alerts']['leavingCompany'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['leavingCompany'][0] + ' is going to leave the company</span>';
        } else if (data['alerts']['leavingCompany'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['leavingCompany']) + ' are going to leave the company</span>';
        }

        if (data['alerts']['notLeavingCompany'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['notLeavingCompany'][0] + ' decided to stay</span>';
        } else if (data['alerts']['notLeavingCompany'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['notLeavingCompany']) + ' decided to stay</span>';
        }

        if (data['alerts']['talentOfferAccepted'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">Offer for ' + data['alerts']['talentOfferAccepted'][0] + ' was accepted</span>';
        } else if (data['alerts']['talentOfferAccepted'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">Offers for ' + commaSeparate(data['alerts']['talentOfferAccepted']) + ' were accepted</span>';
        }

        if (data['alerts']['talentOfferRejected'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">Offer for ' + data['alerts']['talentOfferRejected'][0] + ' was rejected</span>';
        } else if (data['alerts']['talentOfferRejected'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">Offers for ' + commaSeparate(data['alerts']['talentOfferRejected']) + ' were rejected</span>';
        }

        if (data['alerts']['injured'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['injured'][0] + ' suffered an injury</span>';
        } else if (data['alerts']['injured'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['injured']) + ' suffered injuries</span>';
        }

        if (data['alerts']['unhappy'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['unhappy'][0] + ' is unhappy</span>';
        } else if (data['alerts']['unhappy'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['unhappy']) + ' are unhappy</span>';
        }

        if (data['alerts']['notUnhappy'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['notUnhappy'][0] + ' is no longer unhappy</span>';
        } else if (data['alerts']['notUnhappy'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['notUnhappy']) + ' are no longer unhappy</span>';
        }

        if (data['alerts']['injuryRecovered'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['injuryRecovered'][0] + ' is ready to return</span>';
        } else if (data['alerts']['injuryRecovered'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['injuryRecovered']) + ' are ready to return</span>';
        }

        if (data['alerts']['workableInjuryRecovered'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['workableInjuryRecovered'][0] + ' cleared to wrestle</span>';
        }
        else if (data['alerts']['workableInjuryRecovered'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['workableInjuryRecovered']) + ' cleared to wrestle</span>';
        }

        if (data['alerts']['randomEvent'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['randomEvent'][0] + ' event occurred</span>';
        } else if (data['alerts']['randomEvent'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['randomEvent']) + ' events occurred</span>';
        }

        if (data['alerts']['facilityUpgradeAvailable'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['alerts']['facilityUpgradeAvailable'][0] + ' Facility upgrade is available</span>';
        } else if (data['alerts']['facilityUpgradeAvailable'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['alerts']['facilityUpgradeAvailable']) + ' Facility upgrades are available</span>';
        }

        if (data['alerts']['goalCompleted'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item"><span class="goal-color">' + parseObjectiveName(data['alerts']['goalCompleted'][0]) + '</span> Goal completed</span>';
        } else if (data['alerts']['goalCompleted'].length > 1) {
            let goalsCompletedText = Array.from(data['alerts']['goalCompleted'], function (goalCompleted) {
                return '<span class="goal-color">' + parseObjectiveName(goalCompleted) + '</span>';
            });
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(goalsCompletedText) + ' Goals completed</span>';
        }

        if (data['alerts']['goalFailed'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item"><span class="goal-color">' + parseObjectiveName(data['alerts']['goalFailed'][0]) + '</span> Goal failed</span>';
        } else if (data['alerts']['goalFailed'].length > 1) {
            let goalsFailedText = Array.from(data['alerts']['goalFailed'], function (goalFailed) {
                return '<span class="goal-color">' + parseObjectiveName(goalFailed) + '</span>';
            });
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(goalsFailedText) + ' Goals failed</span>';
        }

        if (data['alerts']['talentRequestCompleted'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">Request completed for ' + data['alerts']['talentRequestCompleted'][0] + '</span>';
        } else if (data['alerts']['talentRequestCompleted'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">Requests completed for ' + commaSeparate(data['alerts']['talentRequestCompleted']) + '</span>';
        }

        if (data['alerts']['talentRequestFailed'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">Request failed for ' + data['alerts']['talentRequestFailed'][0] + '</span>';
        } else if (data['alerts']['talentRequestFailed'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">Requests failed for ' + commaSeparate(data['alerts']['talentRequestFailed']) + '</span>';
        }

        // Show available callup alert with View button
        if (data['alerts']['availableCallup']) {
            div += '<span class="display-block dark-grey dashboard-item">A Training Roster Callup is available' +
                '<button type="button" class="button retro-button margin-left-8 condensed grey-button-background no-margin-bottom' +
                ' view-available-callup-button">View</button>' +
                '</span>';
        }
    }

    // Check for no alerts
    const noAlerts = areObjectArraysEmpty(data['alerts']);
    if (noAlerts) {
        div += '<span class="display-block light-grey dashboard-item">No alerts need your attention</span>'
    }

    // Talent requests
    if (data['talentRequests']) {
        div += '<span class="display-block blue margin-top-20">Talent Requests</span>';

        data['talentRequests'].forEach(function (talentRequest) {
            const monthsRemaining = talentRequest['monthsRemaining'];
            let remainingText;
            if (monthsRemaining === 0) {
                remainingText = '(Ends next event)';
            }
            else if (monthsRemaining === 1) {
                remainingText = '(Ends next month)';
            }
            else {
                let monthsWord = getMonthsWord(monthsRemaining);
                remainingText = '(Ends in {0} {1})'.format(monthsRemaining, monthsWord);
            }
            let remainingHtml = '<span class="grey">{0}</span>'.format(remainingText);
            let upcomingMatterText = '{0} <span class="margin-left-2 margin-right-2">-</span> {1} {2}'.format(talentRequest['talentName'], talentRequest['name'], remainingHtml);
            div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(upcomingMatterText);
        });
        if (data['talentRequests'].length === 0) {
            if (!globalUser.paid) {
                div += '<span class="display-block light-grey dashboard-item help-text" title="JoW Paid includes Talent Requests">No active talent requests</span>'
            } else {
                div += '<span class="display-block light-grey dashboard-item">No active talent requests</span>'
            }
        }
    }

    // Upcoming
    div += '<span class="display-block blue margin-top-20">Upcoming</span>';

    // Sort by months remaining
    data['upcomingMatters'].sort(function (a, b) {
        return a['monthsRemaining'] - b['monthsRemaining'];
    });
    data['upcomingMatters'].forEach(function (upcomingMatter) {
        const monthsRemaining = upcomingMatter['monthsRemaining'];
        let remainingText;
        if (monthsRemaining === 1) {
            remainingText = '(Next month)';
        }
        else if (monthsRemaining === 0) {
            remainingText = '(This month)';
        }
        else {
            let monthsWord = getMonthsWord(monthsRemaining);
            remainingText = '({0} {1})'.format(monthsRemaining, monthsWord)
        }
        let remainingHtml = '<span class="grey">{0}</span>'.format(remainingText);
        let upcomingMatterText = '{0} {1}'.format(upcomingMatter['event'], remainingHtml);
        div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(upcomingMatterText);
    });
    if (data['upcomingMatters'].length === 0) {
        div += '<span class="display-block light-grey dashboard-item">No upcoming matters in the near future</span>'
    }

    // Tasks
    div += '<span class="display-block blue margin-top-20">Tasks</span>';

    data['tasksProgress'].forEach(function (taskProgress) {
        const monthsRemaining = (taskProgress['monthsRemaining']) ? taskProgress['monthsRemaining'] : 1;
        let monthsWord = getMonthsWord(monthsRemaining);
        let remainingHtml = '({0} {1} left)'.format(monthsRemaining, monthsWord);
        if (taskProgress['task'].split(' ')[0] === 'Rehabbing') {
            remainingHtml = '(Ongoing)'
        }
        let taskText = '{0} <span class="grey">{1} {2}</span>'.format(taskProgress['task'], taskProgress['staffMember'], remainingHtml);
        div += '<span class="display-block dark-grey dashboard-item">{0}</span>'.format(taskText);
    });
    if (data['tasksProgress'].length === 0) {
        div += '<span class="display-block light-grey dashboard-item">No tasks assigned to staff members</span>'
    }

    // Injured
    div += '<span class="display-block blue margin-top-20">Injured</span>';

    data['injured'].sort(function (a, b) {
        return a['months'] - b['months'] || a['value'] - b['value'];
    });
    data['injured'].forEach(function (injuredItem) {
        div += '<span class="display-block dark-grey dashboard-item">{0} <span class="grey">({1})</span></span>'.format(injuredItem['name'], injuredItem['value']);
    });
    if (data['injured'].length === 0) {
        div += '<span class="display-block light-grey dashboard-item">No roster members are injured</span>'
    }

    // Unavailable
    if (data['unavailable']) {
        div += '<span class="display-block blue margin-top-20">Unavailable</span>';

        if (data['unavailable']['notAvailable'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['unavailable']['notAvailable'][0] + ' <span class="grey"">(Not available this event)</span></span>';
        } else if (data['unavailable']['notAvailable'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['unavailable']['notAvailable']) + ' <span class="grey"">(Not available this event)</span></span>';
        }

        // Get suspended and kayfabe injured superstars and not available staff, sort them by time remaining
        let unavailableArray = data['unavailable']['suspended'].concat(data['unavailable']['kayfabeInjured'], data['unavailable']['notAvailableStaff']);
        unavailableArray.sort(function (a, b) {
            return a['months'] - b['months'] || a['value'] - b['value'];
        });
        unavailableArray.forEach(function (unavailableItem) {
            div += '<span class="display-block dark-grey dashboard-item">{0} <span class="grey">({1})</span></span>'.format(unavailableItem['name'], unavailableItem['value']);
        });

        // Get no appearances
        if (data['unavailable']['noAppearances'].length === 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + data['unavailable']['noAppearances'][0] + ' <span class="grey"">(No appearances left)</span></span>';
        } else if (data['unavailable']['noAppearances'].length > 1) {
            div += '<span class="display-block dark-grey dashboard-item">' + commaSeparate(data['unavailable']['noAppearances']) + ' <span class="grey"">(No appearances left)</span></span>';
        }

        // Check for no unavailable
        const noUnavailable = areObjectArraysEmpty(data['unavailable']);
        if (noUnavailable) {
            div += '<span class="display-block light-grey dashboard-item">No roster members are unavailable</span>'
        }
    }

    $dashboardBox.html(div);

    // View available callup from dashboard
    $dashboardContainer.off('click', '.view-available-callup-button');
    $dashboardContainer.on('click', '.view-available-callup-button', async function () {
        playSoundEffect('success');
        await loadAvailableCallupsPage();
    });
}

export {showDashboardData, dashboardHandler, loadDashboard}